<template>
  <div ref="container">
    <svg ref="hist" :height="height" :width="width">
      <g ref="main" :transform="`translate(${padding[3]}, ${padding[0]})`" class="main"></g>
      <g class="axis axis--x" :transform="`translate(${padding[3]}, ${(innerHeight + padding[0])})`"></g>
      <g class="axis axis--y" :transform="`translate(${padding[3]}, ${padding[0]})`"></g>
    </svg>
    <div ref="tooltip"></div>
  </div>
</template>

<script>
import * as tooltip from "./Tooltip"
import * as d3 from "d3"

export default {
  props: {
    height: { type: Number },
    width: { type: Number },
    padding: { type: Array },
    chartdata: { },
    domain: { type: Array },
    colordomain: { type: Object },
    nbValues: { type: Number }, //0 disable this functionality
  },
  computed: {
    innerHeight() {
      return this.height - (this.padding[0] + this.padding[2])
    },
    innerWidth() {
      return this.width - (this.padding[1] + this.padding[3])
    },
  },
  mounted() {
    this.draw(this.chartdata);
  },
  watch: {
   $props: {
      handler() {
        this.draw(this.chartdata);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    draw(data) {
      if(this.width <= 0 || this.height <= 0) 
        return; //Nothing to do

      //The div which will contain tooltip information
      const tooltipDiv = d3.select(this.$refs.tooltip);
      tooltip.reinit(tooltipDiv);

      let svg = d3.select(this.$refs.hist) 
      // y scale 
      let maxY = d3.max(data.map(d => d.value / (this.nbValues > 0 ? this.nbValues: 1)));
      let y = d3.scaleLinear().domain([0, data.length == 0 ? 0 : maxY]).range([0, this.innerHeight])
      let yReverse = d3.scaleLinear().domain([data.length == 0 ? 0 : maxY, 0]).range([0, this.innerHeight])
      
      // y axis this.height
      let yAxis = d3.axisLeft(yReverse)
                    .tickFormat((x, _i) => (`${this.nbValues > 0 ? (x*100).toFixed(1)+'%' : x}`))
      svg.select(".axis--y").call(yAxis)
      
      // x scale
      let x = d3.scaleBand().range([0, this.innerWidth]).padding(0.1);
      x.domain(this.domain);

      svg.select(".axis--x").call(d3.axisBottom(x).tickSize(0))
                            .selectAll("text")	
                            .attr("dx", "-.8em")
                            .attr("dy", "1em")
                            .attr("transform", "rotate(-10)");

      svg.selectAll(".main").selectAll("rect").data(data)
      .join(
        enter => enter.append("rect")
          .attr("height", d => y(d.value / (this.nbValues > 0 ? this.nbValues : 1)))
          .attr("x", (d) => x(d.name))
          .attr("y", (d) => this.innerHeight - y(d.value / (this.nbValues > 0 ? this.nbValues : 1)))
          .attr("width", x.bandwidth())
          .attr("fill", (d) => this.colordomain[d.name] ? this.colordomain[d.name] : "#000000")
          .attr("stroke", "#ffffff")
          .on("mouseover", (event, d) => {
              tooltip.mouseover(tooltipDiv, event, `Count: ${d.value} ${this.nbValues > 0 ? "("+(d.value/this.nbValues*100).toFixed(2)+"%)":""}`);
          })
          .on("mouseout", function() {
              tooltip.mouseout(tooltipDiv);
          }),
        update => update
          .attr("height", d => y(d.value / (this.nbValues > 0 ? this.nbValues : 1)))
          .attr("x", (d) => x(d.name))
          .attr("y", (d) => this.innerHeight - y(d.value / (this.nbValues > 0 ? this.nbValues : 1)))
          .attr("width", x.bandwidth)
          .attr("fill", (d) => this.colordomain[d.name] ? this.colordomain[d.name] : "#000000")
          .attr("stroke", "#ffffff"),
        exit => exit.remove()
      )
    }
  }
};
</script>
